
import { AuthorizedUser } from '@/types/authorizedUser';
import { ImportFormValues } from './ImportForm';

// Simulate importing users from a database
export const mockImportUsers = async (config: ImportFormValues): Promise<AuthorizedUser[]> => {
  // This is a mock function to simulate a database query
  console.log('Importing users with config:', config);
  
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 2000));
  
  // Generate some fake user data
  const mockUsers: AuthorizedUser[] = [
    { 
      id: "db-1", 
      name: "John Smith", 
      email: "john.smith@example.com", 
      accountNumber: "ACC100200", 
      licenseNumber: "DL500600" 
    },
    { 
      id: "db-2", 
      name: "Sarah Johnson", 
      email: "sarah.j@example.com", 
      accountNumber: "ACC300400", 
      licenseNumber: "DL700800" 
    },
    { 
      id: "db-3", 
      name: "Michael Brown", 
      email: "mike.brown@example.com", 
      accountNumber: "ACC900100", 
      licenseNumber: "DL200300" 
    }
  ];
  
  // Success! Return the mock data
  return mockUsers;
};
